// Shared "you don't have permission for this section" empty state.
//
// Server-side, every League endpoint is gated to committee roles
// (ADMIN / PRESIDENT / VICE_PRESIDENT / GENERAL_SECRETARY / TREASURER
// / EXEC_COMMITTEE_MEMBER / RULES_HEAD / UMPIRING_HEAD /
// SOCIAL_MEDIA_ADMIN). If a signed-in user opens a section without
// one of those roles, every data fetch returns 403. Rendering a
// generic "no data" state in that case is misleading — the section
// isn't empty, the user just can't see it.
//
// Views can catch a fetch error and render <PermissionEmpty /> to
// make the 403 explicit and human-readable.

import React from "react";
import { Lock } from "lucide-react";

export default function PermissionEmpty({ title = "Committee-only section", detail }) {
  return (
    <div className="permissionEmpty">
      <div className="permissionEmpty-icon">
        <Lock size={24}/>
      </div>
      <h3>{title}</h3>
      <p>
        {detail || (
          <>
            You're signed in, but your account doesn't have the roles required
            to view this section. Ask a committee admin to assign you a role in
            <b> Executive Committee → Role Management</b>, then sign back in.
          </>
        )}
      </p>
    </div>
  );
}

export function isPermissionError(err) {
  return err && (err.status === 403 || err.status === 401);
}
